export default "__VITE_ASSET__2098f3b7__"